var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"my-2"},[_c('span',[_vm._v(" Copyright © 2025 by LiveABC Interactive Corporation ")]),_c('span',{staticClass:"pointer disclaimer",attrs:{"target":"_blank"},on:{"click":_vm.goDisclaimer}},[_vm._v("Disclaimer")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }